import { Typography } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";
import { LoadOrRender } from "#/components/LoadOrRender/LoadOrRender";

import { ExpandButton } from "./components/ExpandButton/ExpandButton";
import { GenerateReferralCodeButton } from "./components/GenerateReferralCodeButton/GenerateReferralCodeButton";
import { NextReferral } from "./components/NextReferral/NextReferral";
import { ReferralList } from "./components/ReferralList/ReferralList";
import { useReferralLinksController } from "./ReferralLinks.controller";

export const ReferralLinks = () => {
  const {
    isLoading,
    referralsCount,
    areLinksExpanded,
    referralListItems,
    referralVolumeText,
    shouldShowActionButton,
    isPendingCreateReferral,
    createReferral,
    handleToggleLinksExpanded,
  } = useReferralLinksController();

  return (
    <div className="flex flex-col gap-3 p-8">
      <div className="flex justify-between">
        <div className="flex flex-col gap-3">
          <Typography grotesk element="h3">
            Refer a friend
          </Typography>
          <Typography>{referralVolumeText}</Typography>
        </div>
        <NextReferral />
      </div>

      <div className="flex gap-3">
        <LoadOrRender isLoading={isLoading} className="h-11 w-full rounded-lg">
          <>
            <ReferralList
              items={referralListItems}
              expanded={areLinksExpanded}
            />
            <ExpandButton
              isExpanded={areLinksExpanded}
              referralCount={referralsCount}
              onClick={handleToggleLinksExpanded}
            />
          </>
        </LoadOrRender>

        {shouldShowActionButton && (
          <ConnectWalletWrapper className="mt-0 h-11 min-h-11 w-47">
            <GenerateReferralCodeButton
              isPending={isPendingCreateReferral}
              onClick={createReferral}
            />
          </ConnectWalletWrapper>
        )}
      </div>
    </div>
  );
};
